module.exports = __webpack_public_path__ + "static/media/ball_rolling.b43cbac3.mp3";